import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { VgAPI, VgMedia } from 'videogular2/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {
  @Input() url: string = "assets/videos/pv.mp4";
  
  @ViewChild(VgMedia) media: VgMedia;
  api: VgAPI;
  preload: string = 'auto';
  complete: boolean;
  isPlaying:boolean = false;
  constructor() { }

  ngOnInit() {
  }
  onPlayerReady(api: VgAPI) {
    this.api = api;
  }
  play(url) {
    this.isPlaying = false;
    this.complete = false;
    this.url = url;
    this.media.loadMedia();
    this.media.subscriptions.canPlay.subscribe(this.onLoaded.bind(this));
  }
  onComplete(){
    this.isPlaying = false;
    this.complete = true;
  }
  onLoaded(){
    this.isPlaying = true;
    this.media.play();
    this.api.getDefaultMedia().subscriptions.ended.subscribe(this.onComplete.bind(this));
  }

}



// WEBPACK FOOTER //
// ./src/app/video/video.component.ts